/**
 * Interest value standard display format
 */
export const InterestConverter = (value: number): string =>
	// eslint-disable-next-line implicit-arrow-linebreak
	(value * 100).toFixed(3).toString().split('.').join(',');

export default InterestConverter;
